import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 36000-36999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const clashErrors = {
  // 36xxx is the clashTests module's series. Three sites reused FILE_NOT_FOUND (25025),
  // PROJECT_NOT_FOUND and SPACE_NOT_FOUND (7015) verbatim; three stay generic.
  // 36001-36005 — the clashTests module's split.
  CLASH_ONLY_MERGE_FILE_SUPPORTED: {
    errorCode: 36001,
    errorMessage: t("Only Merge file is supported for clash"),
    isDynamic: false,
  },
  CLASH_TEST_NOT_FOUND: {
    errorCode: 36002,
    errorMessage: t("Clash test not found"),
    isDynamic: false,
  },
  CLASH_TEST_REQUIRES_LATEST_VERSION: {
    errorCode: 36003,
    errorMessage: t("Clash test can only be started on latest version"),
    isDynamic: false,
  },
  // Its own sentence adds "please contact support", so it is not one of the sites that stay on the
  // plain generic code.
  CLASH_UNEXPECTED_CONTACT_SUPPORT: {
    errorCode: 36004,
    errorMessage: t("Something went wrong, please contact support"),
    isDynamic: false,
  },
  CLASH_SETTINGS_UPDATE_FAILED: {
    errorCode: 36005,
    errorMessage: t("Clash settings could not be updated."),
    isDynamic: false,
  },
  CLASH_ALREADY_COMPLETED_IN_VERSION: {
    errorCode: 36006,
    errorMessage: t("Clash has already been completed in this version"),
    isDynamic: false,
  },
  CLASH_CREATE_FIELDS_REQUIRED: {
    errorCode: 36007,
    errorMessage: t("A project, a Space and a merged file are required to create a clash test."),
    isDynamic: false,
  },
  // 36009-36011 came off `clashFailure(<prose>)` in clashTests.service.ts, which set no code at
  // all. ⚠️ 36009 is NOT CLASH_TEST_REQUIRES_LATEST_VERSION (36003): that one refuses STARTING a
  // test on an old version, this one refuses a STATUS CHANGE on one, and the two sentences differ.
  CLASH_STATUS_CHANGE_REQUIRES_LATEST_VERSION: {
    errorCode: 36009,
    errorMessage: t("Status change can only be done on latest clash version."),
    isDynamic: false,
  },
  CLASH_STATUS_NOT_AVAILABLE: {
    errorCode: 36010,
    errorMessage: t("No such status available"),
    isDynamic: false,
  },
  CLASH_UPDATE_FAILED: {
    errorCode: 36011,
    errorMessage: t("Error while updating"),
    isDynamic: false,
  },
  CLASH_VISIBILITY_OPTION_INVALID: {
    errorCode: 36008,
    errorMessage: t("Invalid clash visibility option."),
    isDynamic: false,
  },
  // Staging's `saveClashVersionResult` guard (Cube-16664): `clashFileEmbed` has no optional members,
  // so a merged file with an empty `versions[]` cannot be snapshotted — and cannot be clashed either.
  // Staging sent this sentence as an `errorMessage`; it lives here instead so the refusal travels as
  // a code, with the wording it shipped with unchanged.
  CLASH_MERGE_FILE_NO_VERSION: {
    errorCode: 36012,
    errorMessage: t("Merge file has no version to clash"),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
